import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { Button, Flex } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { setPdfPreviewType } from "../../redux/slices/report/report";
import { resetUpdateEnrollmentData } from "../../redux/slices/school/student";
import { resetUserData } from "../../redux/slices/users/user";
import { routes } from "../../routes";
import { UserPreview } from "../Users/UserPreview";
import { useLogoBase64 } from "../../hooks/useLogoBase64";
import { useExportDocument } from "../../hooks/useExportDocument";
import { RegimeOptions } from "../../utils/studentUtils";
import { useIES } from "../../hooks/useIES";

export const PrintEnrollmentDocs = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {logoBase64} = useLogoBase64();
      const { IES, isLoading } = useIES();
    const { exportDocument } = useExportDocument()
    const enrollmentData = useAppSelector((state) => state.student);
    const handleBack = ()=>{
      dispatch(resetUserData());
      dispatch(resetUpdateEnrollmentData());
      navigate(routes.enrollments);
    }
    const handlePrintStudentCard = async() => {
      const data: any = {
        type: "CARTAO_ESTUDANTE",
        outputFormat: "DOCX",
        data: {
             ies:IES.NAME, 
             ano_lectivo:enrollmentData.enrollment.academicYear, 
             nome_completo:enrollmentData.student?.fullname, 
             regime: RegimeOptions[ enrollmentData.enrollment.regime ?? "1"] ?? "",
             codigo:enrollmentData.student?.schoolCode,
             nue:enrollmentData?.student?.studentUniversalCode===enrollmentData.student?.schoolCode?'N/A':enrollmentData.student?.studentUniversalCode,
             curso:enrollmentData.enrollment.course,
            },
            logoBase64: logoBase64 ?? '',
            avatar:""
       }
      await exportDocument(data, 'CARTAO_ESTUDANTE');
    }
    const handlePrintStudentProcess = () => {
        dispatch(setPdfPreviewType('STUDENT_PROCESS')); 
        navigate(routes.pdfPreview);
    }
    return (
        <>
            <Flex direction='column' gap='4'>
                <UserPreview />

                <Flex gap='4'>
                    <Button color='red' onClick={handleBack}>
                        <ChevronLeftIcon /> voltar
                    </Button>
                    <Button onClick={handlePrintStudentCard}>
                        Imprimir cartão de estudante
                    </Button>
                    <Button onClick={handlePrintStudentProcess}>
                        Imprimir processo
                    </Button>
                </Flex>
            </Flex>
        </>
    )
}
